// Inline nanoid implementation (no CDN dependency)
function nanoid(size = 21) {
  const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789_-';
  const bytes = crypto.getRandomValues(new Uint8Array(size));
  let id = '';
  for (let i = 0; i < size; i++) {
    id += alphabet[bytes[i] & 63];
  }
  return id;
}

document.addEventListener('DOMContentLoaded', function() {
  const currentProductQuantity = document.querySelector('.ProductForm [name="quantity"]');
  const widget = document.querySelector('.recharge-subscription-widget');
  if (!widget) return;

  // Get all elements
  const subscriptionOptionsSubscribe = widget.querySelector('#subscription-options-subscribe');
  const subscriptionOptionsOnetime = widget.querySelector('#subscription-options-onetime');
  const subscribeOption = widget.querySelector('[data-option="subscribe"]');
  const onetimeOption = widget.querySelector('[data-option="onetime"]') || widget.querySelector('.onetime-option');
  const subscribeRadio = widget.querySelector('#subscribe-option');
  const onetimeRadio = widget.querySelector('#onetime-option');
  const sellingPlanInput = widget.querySelector('.selling-plan-input');
  const discountInput = widget.querySelector('.discount-input');
  let rcBundleInput = widget.querySelector('.rc-bundle-input');
  const rcBundleParentInput = widget.querySelector('.rc-bundle-parent-input');
  const rcBundleVariantInput = widget.querySelector('.rc-bundle-variant-input');
  const rcBundleCollectionIdInput = widget.querySelector('.rc-bundle-collection-id-input');

  
  let currentOption = 'subscribe';
  let basePrice = parseFloat(widget.dataset.basePrice) || 0;
  let price = basePrice;
  let productBundleId = widget.dataset.productBundleId;
  let parentBundle = widget.dataset.parentBundle;
  let variantBundleId = widget.dataset.variantBundleId;
  let collectionBundleId = widget.dataset.collectionBundleId;
  
  // Tier plan IDs
  let sellingPlanId = widget.dataset.sellingPlan || '';

  // Configurable discount tiers from theme settings
  let tier1Discount = parseInt(widget.dataset.tier1Discount) || 15;
  let tier2Discount = parseInt(widget.dataset.tier2Discount) || 17;
  let tier3Discount = parseInt(widget.dataset.tier3Discount) || 20;

  subscribeRadio.addEventListener('change', function() {
    if (this.checked) {
      currentOption = 'subscribe';
      subscriptionOptionsSubscribe.classList.add('active');
      subscriptionOptionsOnetime.classList.remove('active');
      updateUI();
    }
  });

  onetimeRadio.addEventListener('change', function() {
    if (this.checked) {
      currentOption = 'onetime';
      subscriptionOptionsSubscribe.classList.remove('active');
      subscriptionOptionsOnetime.classList.add('active');
      updateUI();
    }
  });

  if (subscribeOption) {
    subscribeOption.addEventListener('click', function() {
      subscribeRadio.checked = true;
      currentOption = 'subscribe';
      updateUI();
    });
  }

  if (onetimeOption) {
    onetimeOption.addEventListener('click', function() {
      onetimeRadio.checked = true;
      currentOption = 'onetime';
      updateUI();
    });
  }

  const input = currentProductQuantity;
  let lastValue = input.value;

  const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
              const newValue = input.value;
              if (newValue !== lastValue) {
                  lastValue = newValue;
                  updateUI();
              }
          }
      });
  });

  observer.observe(input, {
    attributes: true,
    attributeFilter: ['value']
  });

  document.addEventListener('rebuy:smartcart.hide', (event) => {
    updateUI();
  });

  function getCurrentQuantity() {
    let qtyInput = document.querySelector('.ProductForm [name="quantity"]');
    if (qtyInput) {
      let value = parseInt(qtyInput.value) || 1;
      return value;
    }
    console.warn('getCurrentQuantity: No quantity input found, returning default value 1');
    return 1;

  }

  function bundleItemsInCart() {
    return fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const bundleItems = cart.items.filter(item => item.properties['_rc_bundle'] !== undefined);
        if (bundleItems.length > 0) {
          return bundleItems;
        } else {
          return null;
        }
      })
      .catch(error => {
        console.error('Error checking cart for bundle items:', error);
        return null;
      });
  }


  function enableBundleInputs() {
    rcBundleInput.disabled = false;
    bundleItemsInCart().then(bundleItems => {
      let fullBundle = ""
      let nanoidstatic = ""
      if (bundleItems) {
        fullBundle = bundleItems[0].properties['_rc_bundle'];
        nanoidstatic = fullBundle.split(':')[0];
        rcBundleInput.value = `${nanoidstatic}:${productBundleId}`;
      } else {
        rcBundleInput.value = `${nanoid(9)}:${productBundleId}`;
      }
      rcBundleParentInput.disabled = false;
      rcBundleParentInput.value = parentBundle;
      rcBundleVariantInput.disabled = false;
      rcBundleVariantInput.value = variantBundleId;
      rcBundleCollectionIdInput.disabled = false;
      rcBundleCollectionIdInput.value = collectionBundleId;
      });
    
  }
  function disableBundleInputs() {  
    rcBundleInput.disabled = true;
    rcBundleParentInput.disabled = true;
    rcBundleVariantInput.disabled = true;
    rcBundleCollectionIdInput.disabled = true;
  }

  function checkBundleItemsInCart() {
    return fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const bundleItems = cart.items.filter(item => item.properties['_rc_bundle'] !== undefined);
        let totalQuantity = 0;
        bundleItems.forEach(item => {
          totalQuantity += item.quantity;
        });
        return totalQuantity;
      })
      .catch(error => {
        console.error('Error checking cart for bundle items:', error);
        return 0;
      });
  }

  function updateTierAndPrice() {
      const currentProductQuantity = getCurrentQuantity();
      return checkBundleItemsInCart().then(productBundleQuantity => {
        const projectedTotal = productBundleQuantity + currentProductQuantity;
    
        let discount;
        if (projectedTotal >= 3) {
          discount = tier3Discount;
        } else if (projectedTotal >= 2) {
          discount = tier2Discount;
        } else {
          discount = tier1Discount;
        }
        price = basePrice * (1 - discount / 100);
        widget.querySelector('.current-price').textContent = `$${price.toFixed(2)}`;
        widget.querySelector('#discount-percent').textContent = ` | ${discount}%`;
      }).catch(error => {
        console.error('Error al actualizar precio con bundles:', error);
      });
  }

  function updateUI() {
    if (subscribeOption) {
      subscribeOption.classList.toggle('active', currentOption === 'subscribe');
    }
    if (onetimeOption) {
      onetimeOption.classList.toggle('active', currentOption === 'onetime');
    }
    
    updateTierAndPrice().then(() => {
      if (currentOption === 'subscribe') {
        enableBundleInputs();
        sellingPlanInput.disabled = false;
        sellingPlanInput.value = widget.dataset.sellingPlan;
        document.querySelector('.js-price-preview').textContent = `$${price.toFixed(2)}`;
      } else {
        if (sellingPlanInput) {
          sellingPlanInput.disabled = true;
        }
        disableBundleInputs();
        document.querySelector('.js-price-preview').textContent = `$${basePrice.toFixed(2)}`;
      }
    });
  }


  window.subscriptionWidget = {
    getCurrentOption: function() {
      return currentOption;
    },
    getCurrentSellingPlan: function() {
      return sellingPlanInput ? sellingPlanInput.value : '';
    },
    getCurrentDiscount: function() {
      return discountInput ? parseInt(discountInput.value) : 0;
    },
    hasActiveSubscription: function() {
      return currentOption === 'subscribe' && sellingPlanInput && sellingPlanInput.value;
    },
    getRechargeData: function() {
      const currentProductQuantity = getCurrentQuantity();
      return checkBundleItemsInCart().then(productBundleQuantity => {
        const projectedTotal = productBundleQuantity + currentProductQuantity;
        let tierDiscount = tier1Discount;
        if (projectedTotal >= 3) {
          tierDiscount = tier3Discount;
        } else if (projectedTotal >= 2) {
          tierDiscount = tier2Discount;
        }

        return {
          variantId: widget.dataset.productId,
          quantity: currentProductQuantity,
          sellingPlan: sellingPlanInput ? sellingPlanInput.value : '',
          tierDiscount: tierDiscount,
          purchaseOption: currentOption,
          projectedTotal: projectedTotal
        };
      });
    },
    checkBundleItemsInCart: function() {
      return checkBundleItemsInCart();
    },
    updateQuantity: function() {
      currentProductQuantity.value = 4;
    }
  };

  updateUI();
});
